import { render } from "./addAppointment.vue?vue&type=template&id=7c628a1c&scoped=true"
import script from "./addAppointment.vue?vue&type=script&lang=js"
export * from "./addAppointment.vue?vue&type=script&lang=js"

import "./addAppointment.vue?vue&type=style&index=0&id=7c628a1c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c628a1c"]])

export default __exports__